import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Locations_ds_projects_ddService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { statusId?: number, ownerId?: number, fullTextSearch?: string }): 
  Promise<{ result: { Id?: number, LookupCode?: string, Name?: string }[] }> 
  {
    let url = `${environment.backendUrl}api/Locations/datasources/ds_projects_dd/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { statusId?: number, ownerId?: number, fullTextSearch?: string, $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, LookupCode?: string, Name?: string }[], totalCount: number }> 
  {
    let url = `${environment.backendUrl}api/Locations/datasources/ds_projects_dd/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { statusId?: number, ownerId?: number, fullTextSearch?: string, $keys: number[] }): 
  Promise<{ result: { Id?: number, LookupCode?: string, Name?: string }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Locations/datasources/ds_projects_dd/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      statusId?: number, ownerId?: number, fullTextSearch?: string    }) {
      return false;
    }
}
